import { Button as DefaultButton } from '@material-ui/core'
import styled from 'styled-components'

export const Button = styled(DefaultButton)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-weight: 500;
  border-color: ${({ theme }) => theme.palette.grey[400]};
  border-radius: 8px;
`
